import { useCallback } from 'react';
import {
  specificTemplateDetailsPageInTemplatesMarketplacePageView,
  specificTemplateDetailsPageInTemplatesMarketplaceGenericClick,
} from '@wix/bi-logger-partners-data/v2';
import { useTemplateContext } from '@components/Contexts/TemplateContext';
import { useBi } from './useBi';
import { EDITOR_TYPES } from '@common/types';
import { useTemplateEntry } from './useTemplateEntry';

export const useTemplateBi = ({ is_mobile }: { is_mobile: boolean }) => {
  const { entry } = useTemplateEntry();
  const {
    template: { id, accountId, platform, hasVeloOrBlocks },
  } = useTemplateContext();

  const logger = useBi();
  const TAB_ID_TO_BI_NAME = {
    about: 'About',
    reviews: 'Reviews',
    seller: 'Seller',
  };

  const getEditorTypeByPlatform = useCallback(() => {
    return platform === EDITOR_TYPES.STUDIO ? 'studio' : 'wix.com';
  }, [platform]);
  const logBiPageView = useCallback(() => {
    const origin = document.referrer;
    logger.report(
      specificTemplateDetailsPageInTemplatesMarketplacePageView({
        ...(is_mobile && { is_mobile }),
        editor_type: getEditorTypeByPlatform(),
        template_id: id,
        template_owner_account_id: accountId,
        ...(entry && { entry }),
        ...(origin && { origin }),
        IsVelo: hasVeloOrBlocks,
      }),
    );
  }, [id, accountId, is_mobile, entry]);

  const logBiClick = useCallback(
    ({ clickType, click_data }: { clickType: string; click_data?: any }) => {
      const origin = document.referrer;
      logger.report(
        specificTemplateDetailsPageInTemplatesMarketplaceGenericClick({
          editor_type: getEditorTypeByPlatform(),
          template_id: id,
          template_owner_account_id: accountId,
          click_type: clickType,
          IsVelo: hasVeloOrBlocks,
          ...(entry && { entry }),
          ...(origin && { origin }),
          ...(is_mobile && { is_mobile }),
          ...(click_data && { click_data: JSON.stringify({ click_data }) }),
        }),
      );
    },
    [id, accountId, is_mobile, entry],
  );

  return {
    logBiPageView,
    logBiClick,
    TAB_ID_TO_BI_NAME,
  };
};
